import { Box, Button, Circle, IconButton, Image, Menu, MenuButton, MenuItem, MenuList, Tooltip, Text } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setEdit } from "../../redux/actions/actions";
import { ReactComponent as ContextMenuIcon } from '../../svg/ContextMenu.svg'
import { ReactComponent as FilesIcon } from '../../svg/Files.svg'
import { ReactComponent as VideoFilesIcon } from '../../svg/video-file.svg'
import { ReactComponent as Enabled } from '../../svg/enabledTopic.svg'
import { ReactComponent as Disabled } from '../../svg/disabledTopic.svg'

export default function IndividualTopicCard({ image, name, dates, files, fileType, quizzes, status, id, removeTopic, quizStatus }) {
    const history = useHistory()
    const dispatch = useDispatch()

    const editHandler = () => {
        dispatch(setEdit(id))
        history.push({
            pathname: '/add-topics',
            state: { id: id }
        })
    }

    return (
        <Box
            d='flex'
            width='100%'
            bg='white'
            borderRadius='20px'
            my='1rem'
            p='1rem'
            px='1rem'
            justifyContent='flex-start'
            alignItems='center'
            _hover={{ boxShadow: 'xl' }}
            position='relative'
        >
            <Box d='flex' width={['15%', '15%', '15%', '35%']} flexDir={['column', 'column', 'column', 'row']} alignItems={['center', 'center', 'center', null]}>
                <Image
                    src={image ? image : './images/unavailable-image.jpg'}
                    width={['50px', '50px', '50px', '50px']}
                    height={['50px', '50px', '50px', '50px']}
                    borderRadius='50%'
                    // fallbackSrc="https://source.unsplash.com/random/800x600" 
                    mr='2'
                    objectFit='cover'
                />
                
                <Box d='flex' flexDir='column' justifyContent='center' alignItems={['center', 'center', 'center', 'flex-start']} w='100%'>
                    <Tooltip
                        label={name}
                        fontSize='15px'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontWeight='400'
                        color='#ffffff'
                        bg='#1B1A1AB2'
                        hasArrow
                        placement='top'
                    >
                        <Text
                            style={{ fontFamily: 'Mulish, sans-serif' }}
                            fontWeight='700'
                            fontSize={['14px', '14px', '16px', '16px']}
                            color='#333333'
                            whiteSpace='nowrap'
                            overflow='hidden'
                            textOverflow='ellipsis'
                            cursor='pointer'
                            w={['100%', '100%', '100%', '80%']}
                        >
                            {name ? name : 'Topic Name'}
                        </Text>
                    </Tooltip>
                    <Text style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='400' fontSize={['8px', '10px', '12px', '16px']} color='#00000080' >{dates}</Text>
                </Box>
            </Box>
            <Box d='flex' width={['30%', '30%', '30%', '15%']} height='100%' justifyContent='center' alignItems='center'>
                <Box d='flex' width='76px' height='39px' color='white' bg='#7B7EE2' border='2px solid #FFFFFF' boxShadow='0px 2px 6px rgba(0, 0, 0, 0.1)' justifyContent='center' alignItems='center' borderRadius='3xl'>
                    {fileType ? <VideoFilesIcon width='18px' height = '18px' /> : <FilesIcon width='16px' height = '16px' />}
                    <Text style={{ fontFamily: 'Mulish, sans-serif' }} ml='1' fontWeight='700' fontSize={['7px', '10px', '11px', '15px']}>{files}</Text>
                </Box>
            </Box>
            <Box d='flex' width={['30%', '30%', '30%', '15%']} justifyContent='center' alignItems='center'>
                <Box
                    bg={status ? '#70B259' : '#F2DBD6'}
                    border='2px solid #FFFFFF'
                    boxShadow='0px 2px 6px rgba(0, 0, 0, 0.1)'
                    p='10px 20px'
                    borderRadius='20px'
                    style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                    fontWeight='700'
                    color={status ? '#ffffff' : '#00000080'}
                    fontSize={['7px', '10px', '11px', '15px']}
                    d='flex'
                    justifyContent='center'
                    alignItems='center'
                >
                    {status ? <Enabled width='15px' height='15px' /> : <Disabled width='15px' height='15px' />}
                    {status ? 'Enabled' : 'Disabled'}
                </Box>
            </Box>
            <Box d='flex' width='15%' justifyContent='center' alignItems='center'>
                <Circle bg='#70B259' size={['22px', '25px', '25px', '40px']} border='1px solid white' color='white' style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize={['7px', '10px', '11px', '15px']}>
                    {quizzes}
                </Circle>
            </Box>
            <Box d='flex' width='15%' justifyContent='center' alignItems='center'>
                <Button
                    bgColor='#70B259'
                    color='white'
                    variant='outline'
                    p={['0.5rem', '0.5rem', '0.5rem', '0.75rem']}
                    size={['xs', 'sm', 'sm', 'md']}
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    borderRadius='lg'
                    fontSize={['7px', '10px', '11px', '15px']}
                    _hover={{ bg: "#64a04f" }}
                    onClick={() => history.push('/add-quizzes')}
                    disabled={status === 'N' || quizStatus.toUpperCase() === 'N'}
                >
                    + Add Quiz
                </Button>
            </Box>
            <Menu>
                <MenuButton
                    as={IconButton}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='10px'
                    icon={<ContextMenuIcon />}
                    bg='white'
                    _hover={{ bg: "#f8f8f8" }}
                    _active={{ bg: "#f8f8f8" }}
                    position={['absolute', 'absolute', 'absolute', 'static']}
                    right='0'
                    top='0'
                    size={['xs', 'sm', 'sm', 'lg']}
                    p='0.5rem 1rem'
                />
                <MenuList style={{ fontFamily: 'Mulish, sans-serif' }} fontWeight='700' fontSize='15px' color='#00000099' minW='0' w='150px' position='relative' zIndex='10'>
                    <MenuItem onClick={editHandler}>Edit</MenuItem>
                    <MenuItem onClick={() => removeTopic(id)}>Delete</MenuItem>
                </MenuList>
            </Menu>
        </Box>
    )
}